import { render, staticRenderFns } from "./skill-editor.vue?vue&type=template&id=6c315594&scoped=true"
import script from "./skill-editor.vue?vue&type=script&lang=js"
export * from "./skill-editor.vue?vue&type=script&lang=js"
import style0 from "./skill-editor.vue?vue&type=style&index=0&id=6c315594&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c315594",
  null
  
)

export default component.exports